import { IWidgetConfigComponentProps } from '@framework/engine';
import { FormItem, SwitchInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import React from 'react';
import { useWatch } from 'react-hook-form';

export interface IIntegrableDirectiveConfigComponentProps
  extends IWidgetConfigComponentProps {}

export function IntegrableDirectiveConfigComponent(
  props: IIntegrableDirectiveConfigComponentProps,
) {
  const isDisabled = useWatch({ name: `${props.name}.disabled` });

  return (
    <RowElement>
      <FormItem
        name={`${props.name}.disabled`}
        label="Disabilitazione Integrazione"
        help={
          <span>
            Se selezionato, l&apos;utente non potrà modificare il campo in fase
            di integrazione.
            <br />
            {isDisabled ? (
              <>
                Il campo attualmente <b>è disabilitato</b> in fase di
                integrazione.
              </>
            ) : (
              <>
                Il campo attualmente <b>è modificabile</b> in fase di
                integrazione.
              </>
            )}
          </span>
        }
        style={{ marginBottom: 48 }}
        layout={{ hideVisualLabel: true }}
      >
        <SwitchInput name={`${props.name}.disabled`} defaultChecked={true}>
          <span>Disabilita la modifica in fase di integrazione</span>
        </SwitchInput>
      </FormItem>
    </RowElement>
  );
}
